import { render, staticRenderFns } from "./StockInventoryToolsDispatcher.vue?vue&type=template&id=63bbdf84&"
import script from "./StockInventoryToolsDispatcher.vue?vue&type=script&lang=js&"
export * from "./StockInventoryToolsDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField} from 'quasar'
component.options.components = Object.assign({QField}, component.options.components || {})
